// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".6c1679710d652fadfea6f24111dacc7b0f7affe2.chunk.js";
};